import { render, staticRenderFns } from "./JobParameters.vue?vue&type=template&id=619f636b&scoped=true"
import script from "./JobParameters.vue?vue&type=script&lang=js"
export * from "./JobParameters.vue?vue&type=script&lang=js"
import style0 from "./JobParameters.vue?vue&type=style&index=0&id=619f636b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619f636b",
  null
  
)

export default component.exports